import FruitCard from "../../layouts/FruitCard";
import bg from "/cywe-assets/card/yellow.png";
import fruit from "/cywe-assets/fruit/pineapple.png";

export default function Yellow({
	setValue,
	value,
}: {
	setValue: (value: number) => void;
	value: number;
}) {
	return (
		<>
			<FruitCard
				title="The Joy of the Lord, your strength!"
				description="The ability to feel pleasure in living and sharing with others. Bringing up a beautiful beam with your presence and smile. Wanting to spread joy and your good success with everyone and that they themselves can share in that joy."
				bg={bg}
				fruit={fruit}
				setValue={setValue}
				value={value}
				back="/experience/2"
				next="/experience/4"
			/>
		</>
	);
}
